export interface TechnicianPersonalDetails {
  email: string;
}

export class AcceptInvitationRequestModel {
  constructor(model: any) {
    const { email, password, link, accept_policy } = model;
    Object.assign(this, { email, password, link, accept_policy });
  }

  email: string;
  password: string;
  link: string;
  acceptPolicy: boolean;
}
